import {GroupICRTN} from 'ApplicationEntry/models/ProductsRiders/ICRTN/GroupICRTN';
import {NewYorkICRTN} from 'ApplicationEntry/models/ProductsRiders/ICRTN/NewYorkICRTN';
import {OrdinaryICRTN} from 'ApplicationEntry/models/ProductsRiders/ICRTN/OrdinaryICRTN';

export type ICRTN = OrdinaryICRTN | GroupICRTN | NewYorkICRTN;

type ExhaustiveICRTNOptionsByType<TReturn> = {
  Ordinary: (ordinary: OrdinaryICRTN) => TReturn;
  Group: (group: GroupICRTN) => TReturn;
  NewYork: (newYork: NewYorkICRTN) => TReturn;
};

type PartialICRTNOptionsByType<TReturn> = {
  Ordinary?: (ordinary: OrdinaryICRTN) => TReturn;
  Group?: (group: GroupICRTN) => TReturn;
  NewYork?: (newYork: NewYorkICRTN) => TReturn;
  _: (app: ICRTN) => TReturn;
};

const isExhaustiveByType = <TReturn>(
  options: ICRTNByTypeOptions<TReturn>
): options is ExhaustiveICRTNOptionsByType<TReturn> => !!options.Ordinary || (!!options.Group && !!options.NewYork);

type ICRTNByTypeOptions<TReturn> = PartialICRTNOptionsByType<TReturn> | ExhaustiveICRTNOptionsByType<TReturn>;

export const matchICRTNByType = <TReturn>(options: ICRTNByTypeOptions<TReturn>) => (app: ICRTN): TReturn => {
  switch (app.key) {
    case 'InvalidOrdinaryICRTN':
    case 'ValidOrdinaryICRTN':
      return isExhaustiveByType(options)
        ? options.Ordinary(app)
        : options.Ordinary
        ? options.Ordinary(app)
        : options._(app);
    case 'InvalidGroupICRTN':
    case 'ValidGroupICRTN':
      return isExhaustiveByType(options) ? options.Group(app) : options.Group ? options.Group(app) : options._(app);
    case 'InvalidNewYorkICRTN':
    case 'ValidNewYorkICRTN':
      return isExhaustiveByType(options)
        ? options.NewYork(app)
        : options.NewYork
        ? options.NewYork(app)
        : options._(app);
  }
};

export const isValidICRTN = (icrtn: ICRTN) =>
  icrtn.key === 'ValidOrdinaryICRTN' || icrtn.key === 'ValidGroupICRTN' || icrtn.key === 'ValidNewYorkICRTN';
